// extracted by mini-css-extract-plugin
module.exports = {"vbox":"vbox-module--vbox--1M0QB","vboxwide":"vbox-module--vboxwide--_cMuB"};